import React from 'react';
import { StyleSheet, View, Linking } from 'react-native';
import Colors from '../constants/Colors';
import { MaterialIcons } from '@expo/vector-icons';
import FilledButton from '../components/FilledButton';
import Plentiful from '../constants/Plentiful';
import { useLocalization } from '../store/utils/useLocalization';

import { AppText } from '../components/AppText';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.primaryColor,
    padding: 30,
    gap: 15,
  },
  header: {
    color: Colors.white,
    fontWeight: 'bold',
    fontSize: 24,
    textAlign: 'center',
  },
  text: {
    color: Colors.white,
    fontWeight: 'bold',
  },
  logo: {
    width: 100,
    height: 100,
  },
});

type ErrorScreenProps = {
  restartCallback: () => void;
  /**
   * True when the error being shown is a stale-bundle ChunkLoadError rather than a genuine
   * crash, so the copy and icon can read as "an update is available" instead of "something
   * went wrong" — same recovery action (restart), different framing.
   */
  isUpdateAvailable?: boolean;
};

export const ErrorScreen = (props: ErrorScreenProps) => {
  const { translation } = useLocalization();
  const header = props.isUpdateAvailable
    ? translation.update_available_header
    : translation.error_screen_header;
  const message = props.isUpdateAvailable
    ? translation.update_available_message
    : translation.error_screen_message;

  return (
    <View style={styles.container}>
      <MaterialIcons
        name={props.isUpdateAvailable ? 'system-update' : 'error-outline'}
        size={96}
        color={props.isUpdateAvailable ? Colors.white : Colors.warningBackground}
      />
      <AppText style={styles.header}>{header}</AppText>
      <AppText style={styles.text}>{message}</AppText>
      <FilledButton
        onPress={props.restartCallback}
        label={translation.restart_app}
        color={Colors.mediumBlue}
        full={true}
      />
      <FilledButton
        onPress={() => Linking.openURL(`mailto:${Plentiful.SUPPORT_EMAIL}`)}
        label={translation.email_support}
        color={Colors.mediumBlue}
        full={false}
      />
    </View>
  );
};
